var _style, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubstation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -2 214 250",
    width: 212,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .fin { fill: #101010; }\n    .zap { fill: white ;stroke:#101010;stroke-width: 5;}\n    .line { fill:none;stroke: #101010;stroke-width: 8;stroke-linecap:round; stroke-linejoin:round; }\n    .sout { stroke: white; }\n    .circle { stroke-width: 5; }\n    .top { stroke-width: 3; }\n    .main { stroke-width: 5; }\n    .line-halo { fill:none;stroke-width: 18; stroke-linecap:round; stroke-linejoin:round;}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 43.7 119.7 L 43.7 229.2 L 19 229.2 L 19 246 L 194 246 L 194 229.2 L 169.6 229.2 L 169.6 119.7 L 194 119.7 L 194 102.9 L 19 102.9 L 19 119.7 Z",
    className: "fin sout main"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107.4,
    cy: 173.2,
    r: 45.4,
    className: "sout fb circle"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 152 65.7 C 152 65.7 175.5 56.6 190.4 39.8 C 205.2 23 204.4 6.4 204.4 6.4",
    className: "sout line-halo"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 147.2 71.8 L 139 71.8 L 139 80 L 147.2 80 L 147.2 88.7 L 139 88.7 L 139 96.9 L 147.2 96.9 L 147.2 102.9 L 160.6 102.9 L 160.6 96.9 L 168.8 96.9 L 168.8 88.7 L 160.6 88.7 L 160.6 80 L 168.8 80 L 168.8 71.8 L 160.6 71.8 L 160.6 64.5 L 147.2 64.5 Z",
    className: "fin"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 147.2 71.8 L 139 71.8 L 139 80 L 147.2 80 L 147.2 88.7 L 139 88.7 L 139 96.9 L 147.2 96.9 L 147.2 102.9 L 160.6 102.9 L 160.6 96.9 L 168.8 96.9 L 168.8 88.7 L 160.6 88.7 L 160.6 80 L 168.8 80 L 168.8 71.8 L 160.6 71.8 L 160.6 64.5 L 147.2 64.5 Z",
    className: "sout top"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 152.7 65.5 C 152.7 65.5 175.8 56.4 190.5 39.5 C 205.1 22.6 204.3 5.9 204.3 5.9",
    className: "line"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 61.4 65.7 C 61.4 65.7 37.9 56.6 23.1 39.8 C 8.2 23 9 6.4 9 6.4",
    className: "sout line-halo"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 66.3 71.8 L 74.4 71.8 L 74.4 80 L 66.3 80 L 66.3 88.7 L 74.4 88.7 L 74.4 96.9 L 66.3 96.9 L 66.3 102.9 L 52.8 102.9 L 52.8 96.9 L 44.6 96.9 L 44.6 88.7 L 52.8 88.7 L 52.8 80 L 44.6 80 L 44.6 71.8 L 52.8 71.8 L 52.8 64.5 L 66.3 64.5 Z",
    className: "fin"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 66.3 71.8 L 74.4 71.8 L 74.4 80 L 66.3 80 L 66.3 88.7 L 74.4 88.7 L 74.4 96.9 L 66.3 96.9 L 66.3 102.9 L 52.8 102.9 L 52.8 96.9 L 44.6 96.9 L 44.6 88.7 L 52.8 88.7 L 52.8 80 L 44.6 80 L 44.6 71.8 L 52.8 71.8 L 52.8 64.5 L 66.3 64.5 Z",
    className: "sout top"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 60.7 65.5 C 60.7 65.5 37.6 56.4 23 39.5 C 8.4 22.6 9.1 5.9 9.1 5.9",
    className: "line"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 101.2 182.6 L 101.2 237.5 L 136.8 166.3 L 114.4 166.3 L 114.4 111.5 L 78.8 182.6 Z",
    className: "zap"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 71.8 L 91.8 71.8 L 91.8 80 L 100 80 L 100 88.7 L 91.8 88.7 L 91.8 96.9 L 100 96.9 L 100 102.9 L 113.5 102.9 L 113.5 96.9 L 121.6 96.9 L 121.6 88.7 L 113.5 88.7 L 113.5 80 L 121.6 80 L 121.6 71.8 L 113.5 71.8 L 113.5 64.5 L 100 64.5 Z",
    className: "fin sout top"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstation);
export default __webpack_public_path__ + "static/media/substation.566a37201a9bfa9945a586e965d26ce4.svg";
export { ForwardRef as ReactComponent };